import { authStoreDefaultValue } from "../../reducers/AuthContextReducer";
import { createContext, useContext } from 'react';
import { AuthContextReducerType } from "../../interfaceTypes";

export const AuthContext = createContext<AuthContextReducerType>({
  ...authStoreDefaultValue,
  setIsLoggedIn: () => { },
  setUserLoader: () => { },
  setLoggedInUser: () => { },
  dispatchAuthAction: () => {
    return;
  },
});

export const useAuthContext = () => useContext(AuthContext);